import { Component, Input, ViewChild } from '@angular/core';
import { MatTooltip, TooltipPosition } from '@angular/material/tooltip';

@Component({
	selector: 'tooltip',
	templateUrl: './tooltip.component.html',
	imports: [MatTooltip]
})
export class TooltipComponent {
	@Input() disabled = false;
	@Input() onClick = false;
	@Input() text!: string;
	@Input() position: TooltipPosition = 'below'; // ['below', 'above', 'left', 'right']
	@Input() positionAtOrigin = false;
	@Input() showDelay = 0;

	@ViewChild('tooltip') tooltip!: MatTooltip;

	constructor() { }

	displayTooltip(show: boolean) {
		if (!this.onClick) return;
		if (!show) this.tooltip.disabled = true;
		if (!this.disabled && show) {
			this.tooltip.disabled = false;
			this.tooltip.show();
		}
	}
}
